module.exports = "<div *ngFor=\"let feedArticle of this.items; let i = index\">\n  <p>\n  render-feed-papers-collection works!\n  </p>\n</div>\n"